import { useQuery } from 'react-query'
import axios from '../utils/axios'
import { API_BASE_URL } from '../constants'

const fetchSystemInfo = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/system-info/`)
  return data
}

export const useSystemInfo = () => {
  return useQuery('system-info', fetchSystemInfo, {
    refetchOnWindowFocus: false,
  })
}
